import { Application } from "@hotwired/stimulus";

const application = Application.start();

// Configure Stimulus development experience
application.debug = false;
window.Stimulus = application;

// Import and register all TailwindCSS Components
import {
  Alert,
  Modal,
  Tabs,
  Popover,
  Slideover,
  Dropdown,
} from "tailwindcss-stimulus-components";
application.register("alert", Alert);
application.register("modal", Modal);
application.register("tabs", Tabs);
application.register("popover", Popover);
application.register("slideover", Slideover);
application.register("dropdown", Dropdown);
// application.register('toggle', Toggle);

import Clipboard from "@stimulus-components/clipboard";
application.register("clipboard", Clipboard);

import AutoSubmit from "@stimulus-components/auto-submit";
application.register("auto-submit", AutoSubmit);

import RailsNestedForm from "@stimulus-components/rails-nested-form";
application.register("nested-form", RailsNestedForm);

import Carousel from "@stimulus-components/carousel";
application.register("carousel", Carousel);

export { application };
